var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#2D3549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21.5C30.47 21.5 29.6 22.12 29.21 23H26.29C25.9 22.12 25.03 21.5 24 21.5C22.97 21.5 22.1 22.12 21.71 23H18.79C18.4 22.12 17.53 21.5 16.5 21.5C15.12 21.5 14 22.62 14 24C14 25.38 15.12 26.5 16.5 26.5C17.53 26.5 18.4 25.88 18.79 25H21.71C22.1 25.88 22.97 26.5 24 26.5C25.03 26.5 25.9 25.88 26.29 25H29.21C29.6 25.88 30.47 26.5 31.5 26.5C32.88 26.5 34 25.38 34 24C34 22.62 32.88 21.5 31.5 21.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a1d7a988bb6e82fe5f64441f2c9fcc98.svg";
export { ForwardRef as ReactComponent };